import { countriesList } from "@fla/common";
import {
  ConsentOrdersRelationshipSchema,
  DatePicker,
  InitialDetails,
  RadioSelect,
  RelationshipIcon,
  Select,
  TextInput,
  TwoFields,
  useNames
} from "@fla/components";
import { yupResolver } from "@hookform/resolvers/yup";
import { selectConsentOrdersBase } from "pages/ConsentOrders";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

interface IProps {
  formId: string;
  store: InitialDetails;
  onSubmit: (values: InitialDetails) => void;
}
export default function Relationship({ onSubmit, formId, store }: IProps) {
  const { handleSubmit, control, watch } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(ConsentOrdersRelationshipSchema)
  });

  const { initialDetails } = useSelector(selectConsentOrdersBase);
  const { spouseFirstName } = useNames({ initialDetails });
  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-8 pb-8 border-b">
        <RelationshipIcon classes="w-14 h-14 mx-auto mb-5" />

        <h3 className="text-center">Relationship Details</h3>
      </div>

      <DatePicker
        title={`When did you and ${spouseFirstName} begin living together?`}
        control={control}
        name="relationship.living_date"
        version="v2"
        // id="relationship.living_date"
        // classes="w-2/3"
      />

      <DatePicker
        title="When did you finally separate?"
        control={control}
        name="relationship.separation_date"
        version="v2"
        // id="relationship.separation_date"
        // classes="w-2/3"
      />

      <RadioSelect
        title={`Did you and ${spouseFirstName} get married?`}
        control={control}
        name="relationship.if_married"
        id="relationship.if_married"
        options={["yes", "no"]}
      />

      {watch("relationship.if_married") === "yes" ? (
        <>
          <DatePicker
            title="When did you get married?"
            control={control}
            name="relationship.marriage_date"
            version="v2"
            // id="relationship.marriage_date"
            // classes="w-2/3"
          />

          <TwoFields title="Where did you get married?">
            <TextInput
              title="City/Town"
              titleClasses="text-gray-500 font-semibold uppercase text-xs"
              control={control}
              name="relationship.marriage_city"
              id="relationship.marriage_city"
              placeholder=""
              wrapClasses="col-span-1"
            />

            <Select
              title="Country"
              titleClasses="text-gray-500 font-semibold uppercase text-xs"
              control={control}
              name="relationship.marriage_country"
              id="relationship.marriage_country"
              placeholder="Select Country"
              options={countriesList.map(country => ({
                label: country.name,
                value: country.name
              }))}
            />
          </TwoFields>
          <RadioSelect
            title={`Have you and ${spouseFirstName} divorced?`}
            subTitle="E.g. You have a certificate of divorce or a court has made a divorce order."
            control={control}
            name="relationship.if_divorced"
            id="relationship.if_divorced"
            options={["yes", "no"]}
          />
        </>
      ) : null}

      {watch("relationship.if_divorced") === "yes" ? (
        <>
          <DatePicker
            title="When did you get divorced?"
            control={control}
            name="relationship.divorce_date"
            version="v2"
            // id="relationship.divorce_date"
            // classes="col-span-1"
          />

          <TwoFields title="Where did you get divorced?">
            <TextInput
              title="City/Town"
              titleClasses="text-gray-500 font-semibold uppercase text-xs"
              control={control}
              name="relationship.divorce_city"
              id="relationship.divorce_city"
              placeholder=""
              wrapClasses="col-span-1"
            />

            <Select
              title="Country"
              titleClasses="text-gray-500 font-semibold uppercase text-xs"
              control={control}
              name="relationship.divorce_country"
              id="relationship.divorce_country"
              placeholder="Select Country"
              options={countriesList.map(country => ({
                label: country.name,
                value: country.name
              }))}
            />
          </TwoFields>
        </>
      ) : null}
    </form>
  );
}

/*
list of Australian States
Overseas 

show the country (drop down)
shw input box - overseas_state

*/
